import { isSessionExpired } from './sessionUtils';

type StoredSession = {
  sessionId: string;
  startedAt: string;
  lastSeenAt?: string | null;
  userId?: string | null;
} | null;

type SessionIdentity = {
  sessionId: string;
  startedAt: string;
  lastSeenAt: string;
  storedUserId: string | null;
};

const generateSessionId = (): string => {
  if (
    typeof crypto !== 'undefined' &&
    typeof crypto.randomUUID === 'function'
  ) {
    return crypto.randomUUID();
  }
  return `session-${Date.now()}-${Math.random().toString(16).slice(2)}`;
};

export const resolveSessionIdentity = (
  stored: StoredSession,
  now: Date = new Date()
): SessionIdentity => {
  if (stored && !isSessionExpired(stored, now)) {
    return {
      sessionId: stored.sessionId,
      startedAt: stored.startedAt,
      lastSeenAt: stored.lastSeenAt ?? stored.startedAt,
      storedUserId: stored.userId ?? null,
    };
  }

  const timestamp = now.toISOString();
  return {
    sessionId: generateSessionId(),
    startedAt: timestamp,
    lastSeenAt: timestamp,
    storedUserId: null,
  };
};
